import * as React from "react";
import TextField from "@mui/material/TextField";
import { Box, FormControl, FormHelperText, InputLabel } from "@mui/material";

const DatePickerComponent = ({
    label = "Select date",
    value,
    name,
    helperText,
    error = false,
    fullWidth = true,
    disabled,
    onChange,
    minDate = false,
    id,
}) => {
    const handleDateChange = (event) => {
        if (onChange) {
            onChange(event.target.value);
        }
    };

    return (
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "6px" }}>
            <InputLabel sx={{ fontSize: "14px", color: "#454545", fontWeight: "500" }} shrink={false}>
                {label}
            </InputLabel>
            <TextField
                // label={label}
                type="date"
                value={value || ""}
                onChange={handleDateChange}
                name={name}
                id={id}
                size="small"
                fullWidth={fullWidth}
                disabled={disabled}
                error={error}
                helperText={error ? helperText : ""}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    min: minDate,
                }}
            />
        </Box>
    );
};

export default DatePickerComponent;
